//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import ValidationMixin from '../../../../common/form/mixins/ValidationMixin';

export default {
  name: 'MemberGender',
  mixins: [ValidationMixin],
  props: {
    value: {
      type: String,
      default: null,
    },
    updating: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: true,
    },
  },
  data: function data() {
    return {
      options: [
        { value: '', text: 'Sex' },
        { value: 'F', text: 'Female' },
        { value: 'M', text: 'Male' },
        { value: 'O', text: 'Prefer not to say' },
        { value: 'O', text: 'I am not represented' },
      ],
    };
  },
  validations() {
    if (this.required) {
      return {
        value: {
          required,
        },
      };
    }
    return {};
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.value.required) {
        errors.push('Sex is required');
      }
      return errors;
    },
  },
};
